import React from 'react'
import { useSelector } from 'react-redux'
import objectQuery from 'loankeeper-common/containers/objectQuery'

import { getPermissions } from '../../../store/permissions'

export const usePermissions = () => useSelector(getPermissions)

/**
 * HOC that fetches and then passes permissions to your component
 *
 * @param {Object} config
 * @param {ObjectQuery} [query='* as permissions'] @see ObjectQuery
 *
 * @returns {function(component: React.Component): React.Component}
 */
const withConstantPermissions = (query = '* as permissions') => (Component) => (props) => {
  const permissions = usePermissions()
  return <Component {...props} {...objectQuery(permissions, query)} />
}

export const withAllowed = (Component) => ({ permission, ...rest }) => {
  const permissions = usePermissions()

  if (permissions && permission && !permissions[permission]) {
    return null
  }

  return <Component {...rest} />
}

export default withConstantPermissions
